import React from 'react';
import ResumeDownload from './ResumeDownload';
import 'font-awesome/css/font-awesome.min.css';
import { useLanguage } from '../../context/LanguageContext';

export interface ContactProps { }

const Contact: React.FC<ContactProps> = () => {
    const { t } = useLanguage();

    return (
        <section className="quienSoy contact-page-section">
            <div className="infoSobreMi" id="sobre-mi">
                <div className="ancho">
                    <div className="experiencia">
                        <h2>{t('contact_title')}</h2>
                        <p className="contact-lead-text">{t('contact_subtitle')}</p>

                        <a
                            href="https://www.linkedin.com/in/jose-eduardo-rendon-valencia-362329221/"
                            target="_blank"
                            rel="noreferrer"
                            className="caja"
                        >
                            <div className="contenido">
                                <h3>LinkedIn</h3>
                                <p>Jose Eduardo Rendón Valencia</p>
                            </div>
                            <i className="fa fa-linkedin"></i>
                        </a>

                        <a
                            href="mailto:gmail@joseeduardo.com.co"
                            target="_blank"
                            rel="noreferrer"
                            className="caja"
                        >
                            <div className="contenido">
                                <h3>{t('contact_email')}</h3>
                                <p>gmail@joseeduardo.com.co</p>
                            </div>
                            <i className="fa fa-envelope-o"></i>
                        </a>

                        <a
                            href="https://wa.me/573133185893"
                            className="caja"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className="contenido">
                                <h3>WhatsApp</h3>
                                <p>+57 313 318 5893</p>
                            </div>
                            <i className="fa fa-whatsapp"></i>
                        </a>

                        <a
                            href="https://github.com/eduartdeveloper"
                            className="caja"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className="contenido">
                                <h3>GitHub</h3>
                                <p>@eduartdeveloper</p>
                            </div>
                            <i className="fa fa-github"></i>
                        </a>
                    </div>
                    <div className="sobreMi">
                        <div className="content">
                            <img src="/jose.jpeg" alt="Jose Eduardo Rendón" className="imgYo" />
                        </div>
                    </div>
                </div>
                <div className="ancho" style={{ marginTop: 24 }}>
                    <ResumeDownload variant="card" />
                </div>
            </div>
        </section>
    );
};

export default Contact;
